import { H3 } from 'UIComponents/elements/headings';
import { useSelector } from 'react-redux';
import { Step } from 'signup-constants/Step';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { useExperiment, TrackWhen } from '../experiments/useExperiment';
import { getStepTitle } from '../utils/getStepTitle';
import { OptionalFormattedMessage } from '../views-components/OptionalFormattedMessage';
import { getCurrentStep } from '../store/flow/selectors';
import { getProductShortName } from '../store/purchase/selectors';
import ExistingAccountsErrorModal from '../step-existing-accounts/ExistingAccountsErrorModal';

//This is a temporary solution to avoid showing the modal. This will be based on an API reponse.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const shouldShowModal = false;
export const OptionalTitleContainer = () => {
  const stepKey = useSelector(getCurrentStep);
  const title = useSelector(getStepTitle);
  const {
    isAssignedToVariant: isACQ0151Variant
  } = useExperiment(ExperimentKeys.ACQ0151, TrackWhen.never);
  const productShortName = useSelector(getProductShortName);
  if (isACQ0151Variant() && stepKey === Step.ChooseSeats) {
    return /*#__PURE__*/_jsx(AnimatedStepBody, {
      animationDelay: true,
      children: /*#__PURE__*/_jsxs(H3, {
        children: [/*#__PURE__*/_jsx(OptionalFormattedMessage, {
          message: title
        }), "\xA0", productShortName]
      })
    });
  }
  if (stepKey === Step.ExistingAccounts && shouldShowModal) {
    return /*#__PURE__*/_jsx(ExistingAccountsErrorModal, {});
  }
  return null;
};